import api from './api';

export const getProjects = (params) =>
  api.get('/api/projects', { params: typeof params === 'string' ? { tenantId: params } : params });

export const getProject = (id) => api.get(`/api/projects/${id}`);

export const createProject = (data) => api.post('/api/projects', data);

export const updateProject = (id, data) => api.put(`/api/projects/${id}`, data);

export const deleteProject = (id) => api.delete(`/api/projects/${id}`);

export const addProjectComment = (id, content) =>
  api.post(`/api/projects/${id}/comment`, { content });

// ── Attachments ───────────────────────────────────────────────────────────────
export const uploadAttachment = (projectId, formData) =>
  api.post(`/api/projects/${projectId}/attachments`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteAttachment = (projectId, attachId) =>
  api.delete(`/api/projects/${projectId}/attachments/${attachId}`);

export const getAttachmentFileUrl = (projectId, attachId, options = {}) => {
  const base = `/api/projects/${projectId}/attachment/${attachId}/file`;
  return options.download ? `${base}?download=1` : base;
};

// ── Assessment ────────────────────────────────────────────────────────────────
export const getAssessment = (projectId) =>
  api.get(`/api/projects/${projectId}/assessment`);

// ── Community Reports ─────────────────────────────────────────────────────────
export const getProjectReports = (projectId) =>
  api.get(`/api/projects/${projectId}/reports`);

export const addProjectReport = (projectId, data) =>
  api.post(`/api/projects/${projectId}/reports`, data);

